export const PromiseState = {
    PENDING: 'pending',
    FULFILLED: 'fulfilled',
    REJECTED: 'rejected'
};

export function trackPromise(promise) {
    if (!(promise instanceof Promise)) {
        throw new TypeError('Input must be a Promise');
    }
    const created = Date.now();
    let state = PromiseState.PENDING;
    let value = undefined;
    let error = undefined;


    // Create a new promise that we can track
    const trackedPromise = Promise.race([promise])
        .then(data => {
            state = PromiseState.FULFILLED;
            value = data;
            return data;
        })
        .catch(err => {
            state = PromiseState.REJECTED;
            error = err;
            throw err;
        });

    // Add methods to check state and get results
    return Object.assign(trackedPromise, {
        isPending: () => state === PromiseState.PENDING,
        isFulfilled: () => state === PromiseState.FULFILLED,
        isRejected: () => state === PromiseState.REJECTED,
        getState: () => state,
        getValue: () => value,
        getError: () => error,
        getAge: () => created,
    });
}